import {useMutation, useQuery} from "@tanstack/react-query";
import {SessionAPI} from "../api/session.api";
import {sessionKeys} from "./session.keys";
import {Artist, convertArtistToType} from "src/utils/artist.utils";

export const useGetSessionStatusQuery = (artist: Artist) => {
  const type = convertArtistToType(artist);
  return useQuery({
    queryKey: [...sessionKeys.all, type],
    queryFn: () => SessionAPI.fetchSessionStatus({query: {type}}),
  });
};

export const useClearSessionMutation = () =>
  useMutation({
    mutationFn: () => SessionAPI.clearSession(),
  });
